import { render, staticRenderFns } from "./NewGoodsList.vue?vue&type=template&id=758c76da&scoped=true"
import script from "./NewGoodsList.vue?vue&type=script&lang=js"
export * from "./NewGoodsList.vue?vue&type=script&lang=js"
import style0 from "./NewGoodsList.vue?vue&type=style&index=0&id=758c76da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758c76da",
  null
  
)

export default component.exports